<template>
  <div class="category-cont">
    <div v-for="(category) in categories" ref="linksRef" class="category-item" :key="category.id"
      :class="{ active: category === value }">
      <div @click="onClickCategory(category)" class="category">
        {{ category.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Category",
  data() {
    return {};
  },
  mounted() {
    this.scrollIntoActiveCategory();
  },
  watch: {
    value(activeCategory) {
      const activeIndex = this.categories.findIndex(element => element.id === activeCategory.id);
      this.scrollIntoActiveCategory(activeIndex);
    }
  },
  methods: {
    onClickCategory(item) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      this.$emit('input', item);
    },
    scrollIntoActiveCategory(index = 0) {
      if (this.$refs && this.$refs.linksRef && this.$refs.linksRef[index]) {
        try {
          this.$refs.linksRef[index].scrollIntoView({
            behavior: "auto",
            block: "center",
            inline: "center",
          });
        } catch (e) {
          console.log(e);
        }
      }
    },
  },
  props: {
    categories: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
    },
  },
};
</script>

<style scoped lang="scss">
.category-cont {
  flex: 1;
  display: flex;
  flex-direction: column;
  max-height: 750px;
  overflow: hidden auto;
  padding-right: 15px;
  margin-right: 15px;
  border-right: 2px solid #e0e0e0;
  position: fixed;
  top: 96px;
  bottom: 30px;
  z-index: 10;

  @media (max-width: 700px) {
    flex-direction: row;
    overflow: auto hidden;
    padding: 6px 0;
    margin-right: 0;
    margin-bottom: 20px;
    border-right: 0;
    position: relative;
    top: auto;
    bottom: auto;
    z-index: 0;
  }

  ul {
    list-style-type: none;
  }
}

.category-item {
  display: flex;
  padding-bottom: 6px;

  .category {
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    /* number of lines to show */
    line-clamp: 1;
    -webkit-box-orient: vertical;
    display: block;
    cursor: pointer;
    border-radius: 5px;
    background-color: #e0e0e0;
    color: #232323;
    font-size: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 10px 16px;
    position: relative;
    font-weight: 400;
    margin: 0 1px;
    transition: 0.3s all;

    @media (max-width: 700px) {
      white-space: nowrap;
      width: auto;
    }
  }


  &.active .category {
    font-weight: bold;
    background-color: rgba(15, 67, 123);
    color: #fff;
  }
}
</style>
